import { BreadcrumbStyled } from './styles/BreadcrumbStyled'
import { formatCrumbName } from './utils'

export interface IBreadcrumbProps {
  children: string
  escapeCaseFormatting?: boolean
}

export const Breadcrumb = ({
  children,
  escapeCaseFormatting,
}: IBreadcrumbProps) => (
  <BreadcrumbStyled aria-current='page'>
    {formatCrumbName(children, escapeCaseFormatting)}
  </BreadcrumbStyled>
)

Breadcrumb.displayName = 'Breadcrumb'
